import breakoutInstance from "./axios-instances/breakoutInstance";
import constants from "@/constants";
import { buildOccupancyUrl } from "@/utils/breakout";

export function fetchBreakoutBotStatus() {
    return breakoutInstance.get("/bot");
}

/** Public S3 occupancy JSON (no Bearer). Bust browser/S3 edge cache each poll. */
export async function fetchOccupancySnapshot(meetingNumber) {
    const baseUrl = buildOccupancyUrl(
        constants.occupancyPublicBaseUrl,
        meetingNumber
    );
    if (!baseUrl) {
        return null;
    }
    const url = `${baseUrl}?t=${Date.now()}`;
    const response = await fetch(url, { cache: "no-store" });
    if (!response.ok) {
        throw new Error(`Occupancy fetch failed (${response.status})`);
    }
    return response.json();
}

export function fetchBreakoutParticipants(meetingNumber) {
    return breakoutInstance.get(`/meetings/${meetingNumber}/participants`);
}

export function fetchBreakoutJob(jobId) {
    return breakoutInstance.get(`/jobs/${jobId}`);
}

/** Rejoin from saved session when bot is idle / kicked. */
export function ensureBreakoutBotJoined(meetingNumber) {
    return breakoutInstance.post(`/meetings/${meetingNumber}/ensure-joined`);
}

/** Queue move via SQS (preferred). */
export function queueBreakoutParticipantMove(meetingNumber, payload) {
    return breakoutInstance.post(`/meetings/${meetingNumber}/participants/move`, payload);
}

/** Immediate move (fallback if SQS unavailable). */
export function syncBreakoutParticipantMove(meetingNumber, payload) {
    return breakoutInstance.post(
        `/meetings/${meetingNumber}/participants/move?sync=true`,
        payload
    );
}
